export default __webpack_public_path__ + "static/media/500px.055fd790.svg";